module.exports = ['PR', 'AS', 'FM', 'GU', 'MH', 'MP', 'PW']


// WEBPACK FOOTER //
// ./app/scripts/data/us-territories.coffee